<template>
  <div>
    <v-data-table
        :headers="headers"
        :items="items"
        :loading="isLoading"
        :hide-actions="true"
    >
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
      <template v-slot:items="{ item }">
        <tr>
          <td class="text-xs-left">
            {{ item.name }}
            <icon-tooltip :enabled="item.system" :tooltip-text="trans('app.prescriptions.system_prescription')">
              <v-btn flat icon color="success" class="mr-0 ml-0">
                <i class="logo-small"></i>
              </v-btn>
            </icon-tooltip>
            <icon-tooltip :tooltip-text="trans('app.sharing.shared_by', {name: item.owned_by})"
                          :enabled="item.shared"
            >
              <v-icon small color="success">share</v-icon>
            </icon-tooltip>
          </td>
          <td class="text-xs-center">
            <span v-if="item.sent_to_mobile_app_at">{{ item.sent_to_mobile_app_at|format_date(FORMAT_DATETIME) }}</span>
            <span v-else>-</span>
          </td>
          <td class="justify-end layout px-0 pr-4">
            <v-layout align-center justify-end>
              <icon-button
                  :icon="`mobile_off`"
                  :color="`red`"
                  cls="mr-0 ml-0"
                  :tooltip="{top: true, bottom: false, attach: false}"
                  :iconOptions="{small: true}"
                  @click="removePrescription(item)"
              >
                {{ 'app.mobile_app.prescriptions.remove' | trans }}
              </icon-button>
            </v-layout>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {trans} from "../../../app";
import {mapGetters} from "vuex";
import {FORMAT_DATETIME} from "../../../utils/dateFormatter";

export default {
  props: {
    patient_id: {
      type: Number,
    },
  },
  data() {
    return {
      isLoading: false,
      parser: new DOMParser(),
      items: [],
      prescriptions: [],
      FORMAT_DATETIME: FORMAT_DATETIME,
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.isLoading = true;
      const response = await axios.get(`/v2/patients/${this.patient_id}/prescriptions`)
      const {data} = response.data;
      this.prescriptions = data;
      this.items = this.prescriptions;
      this.isLoading = false;
    },
    addPrescription(prescription) {
      this.items.unshift(prescription);
    },
    removePrescription(prescription) {
      this.$confirmDanger(trans('app.mobile_app.prescriptions.remove_confirmation')).then(() => {
        this.items = this.items.filter(item => item.id !== prescription.id);
        this.$emit('prescriptionRemoved', prescription);
      }).catch((error) => {
        this.sentryCaptureException(error);
      });

    },
  },
  computed: {
    ...mapGetters(['hasPermission']),
    headers() {
      return [
        {
          text: trans('app.name'), align: 'left', value: 'name', sortable: false,
        },
        {
          text: trans('app.mobile_app.prescriptions.sent_at'), align: 'center', value: 'sent_to_mobile_app_at', sortable: false,
        },
        {
          text: '', align: 'right', sortable: false,
        },
      ];
    },
  },
}
</script>
